import React, { useState, useEffect } from 'react';
import { Pagination, PaginationItem, PaginationLink, Input, Row, Col } from 'reactstrap';

const PaginationComponent = ({ totalItems, itemsPerPage, onPageChange, onRowsPerPageChange, siblingCount = 1 }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    setTotalPages(Math.ceil(totalItems / itemsPerPage));
    if (currentPage > totalPages) {
      setCurrentPage(1); // Reset to first page if the new total pages are fewer than the current page
      onPageChange(1);    // Notify parent component
    }
  }, [totalItems, itemsPerPage, currentPage, totalPages, onPageChange]);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      onPageChange(page);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      handlePageChange(currentPage + 1);
    }
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      handlePageChange(currentPage - 1);
    }
  };

  const handleRowsPerPageChange = (e) => {
    const newRowsPerPage = parseInt(e.target.value);
    onRowsPerPageChange(newRowsPerPage);
    setCurrentPage(1);  // Reset to page 1 on rows per page change
    onPageChange(1);     // Notify parent to display the first page
  };

  const generatePageNumbers = () => {
    const totalNumbers = siblingCount * 2 + 3; // 3 = current page + 2 edges
    const totalBlocks = totalNumbers + 2; // 2 for ellipsis (...)

    if (totalPages > totalBlocks) {
      const startPage = Math.max(2, currentPage - siblingCount);
      const endPage = Math.min(totalPages - 1, currentPage + siblingCount);

      let pages = [];

      if (startPage > 2) {
        pages.push(1, '...');
      } else {
        pages.push(1);
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      if (endPage < totalPages - 1) {
        pages.push('...', totalPages);
      } else {
        pages.push(totalPages);
      }

      return pages;
    } else {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
  };

  const pageNumbers = generatePageNumbers();

  return (
    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between', padding: '1rem' }}>
      <Row className='g-0 w-100 align-items-center row-gap-2'>
        <Col xl='9' lg='9'>
          <Pagination style={{ display: 'flex', justifyContent: 'center', margin: "0" }} size='lg'>
            {/* <PaginationItem disabled={currentPage === 1}>
              <PaginationLink first onClick={() => handlePageChange(1)} />
            </PaginationItem> */}
            <PaginationItem disabled={currentPage === 1}>
              <PaginationLink previous onClick={handlePrev} />
            </PaginationItem>
            {pageNumbers.map((page, index) => (
              <PaginationItem key={index} active={currentPage === page} disabled={page === '...'}>
                <PaginationLink onClick={() => typeof page === 'number' && handlePageChange(page)}>
                  {page}
                </PaginationLink>
              </PaginationItem>
            ))}
            <PaginationItem disabled={currentPage === totalPages}>
              <PaginationLink next onClick={handleNext} />
            </PaginationItem>
            {/* <PaginationItem disabled={currentPage === totalPages}>
              <PaginationLink last onClick={() => handlePageChange(totalPages)} />
            </PaginationItem> */}
          </Pagination>
        </Col>
        <Col xl='3' lg='3'>
          <div className="d-flex align-items-center">
            <Input
              type="select"
              id="rowsPerPage"
              value={itemsPerPage}
              onChange={handleRowsPerPageChange}
            >
              <option value="3">3 Rows per Page</option>
              <option value="7">7 Rows per Page</option>
              <option value="14">14 Rows per Page</option>
              <option value="40">40 Rows per Page</option>
              <option value="80">80 Rows per Page</option>
              <option value="100">100 Rows per Page</option>
            </Input>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default PaginationComponent;
